import { create } from 'zustand';
import { storeService } from '../services/storeService';

interface FavoritesStore {
  favoriteIds: number[];
  loaded: boolean;
  loadFavoriteIds: () => Promise<void>;
  toggleFavorite: (productId: number) => Promise<boolean>;
  isFavorited: (productId: number) => boolean;
  reset: () => void;
}

export const useFavoritesStore = create<FavoritesStore>((set, get) => ({
  favoriteIds: [],
  loaded: false,

  loadFavoriteIds: async () => {
    try {
      const ids = await storeService.getFavoriteIds();
      set({ favoriteIds: ids, loaded: true });
    } catch {
      set({ favoriteIds: [], loaded: true });
    }
  },

  toggleFavorite: async (productId) => {
    const wasFavorited = get().favoriteIds.includes(productId);

    set((state) => ({
      favoriteIds: wasFavorited
        ? state.favoriteIds.filter((id) => id !== productId)
        : [...state.favoriteIds, productId],
    }));

    try {
      const { isFavorited } = await storeService.toggleFavorite(productId);
      set((state) => ({
        favoriteIds: isFavorited
          ? state.favoriteIds.includes(productId)
            ? state.favoriteIds
            : [...state.favoriteIds, productId]
          : state.favoriteIds.filter((id) => id !== productId),
      }));
      return isFavorited;
    } catch (error) {
      set((state) => ({
        favoriteIds: wasFavorited
          ? state.favoriteIds.includes(productId)
            ? state.favoriteIds
            : [...state.favoriteIds, productId]
          : state.favoriteIds.filter((id) => id !== productId),
      }));
      throw error;
    }
  },

  isFavorited: (productId) => get().favoriteIds.includes(productId),

  reset: () => set({ favoriteIds: [], loaded: false }),
}));
